export default __webpack_public_path__ + "static/media/vuem-logo-white.c9517692.svg";